import moment, { Moment } from 'moment'

const PRODUCT_DATE_FORMAT = 'YYYY-MM-DD'

export function toProductDateFormValue(value?: unknown): Moment | undefined {
  if (!value) return undefined

  const date = moment.isMoment(value)
    ? value
    : typeof value === 'string'
    ? moment(value, [moment.ISO_8601, PRODUCT_DATE_FORMAT], true)
    : value instanceof Date || typeof value === 'number'
    ? moment(value)
    : undefined

  return date?.isValid() ? date : undefined
}

export function toProductDatePayloadValue(value?: unknown) {
  const date = toProductDateFormValue(value)

  return date ? date.format(PRODUCT_DATE_FORMAT) : ''
}
